module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"collectable":"Colecionável","description":"Descrição","digital-media":"Mídia digital","general-item":"Item","price":"Valor","quantity":"Quantidade"}}')
  delete Component.options._Ctor
}
